/**
 * ErrorView component for displaying error states
 */
interface ErrorViewProps {
  /**
   * The error message to display
   */
  message?: string
  /**
   * Optional title (defaults to "Error")
   */
  title?: string
}

export function ErrorView({ message, title = 'Error' }: ErrorViewProps) {
  return (
    <div className="flex flex-col justify-center items-center py-12">
      <p className="text-brick text-lg font-medium">{title}</p>
      {message && <p className="mt-2 text-charcoal-50">{message}</p>}
    </div>
  )
}
